import {
  ListUpgradePlansResponse,
  UpgradeCreationStatus,
  UpgradePlanStatus,
  UpgradePlanUser,
} from 'api/admin-models';

export interface UpgradesTableElement {
  AccountId: string;
  Id: string;
  Name: string;
  Status: UpgradePlanStatus;
  CreationStatus: UpgradeCreationStatus;
  RequestedBy?: UpgradePlanUser;
  Assignee?: string;
  ClusterId?: string;
  AddonInstanceId?: string;
  ResourceId?: string;
  Created: number;
  Updated?: number;
}

export function fromApiResponses(
  data: ListUpgradePlansResponse[] | undefined,
): UpgradesTableElement[] | undefined {
  if (data === undefined) {
    return undefined;
  }

  const results = data.reduce<UpgradesTableElement[]>((acc, res) => {
    const mappedData = res.data.map<UpgradesTableElement>((uav) => ({
      AccountId: uav.account_id,
      Id: uav.upgrade.id,
      Name: uav.upgrade.name,
      Status: uav.upgrade.status,
      CreationStatus: uav.creation_status,
      Assignee: uav.assignee,
      ClusterId: uav.upgrade.resources.clusters?.[0]?.id,
      AddonInstanceId: uav.upgrade.resources.addon_instances?.[0]?.id,
      ResourceId: uav.upgrade.resources.addon_instances?.[0]?.id || uav.upgrade.resources.addons?.[0]?.id ||  uav.upgrade.resources.clusters?.[0]?.id,
      Created: uav.upgrade.created,
      Updated: uav.upgrade.updated,
      RequestedBy: uav.upgrade.requested_by,
    }));

    return acc.concat(...mappedData);
  }, []);

  return results;
}
